import { render, staticRenderFns } from "./SQLEdit.vue?vue&type=template&id=285a62a9&"
import script from "./SQLEdit.vue?vue&type=script&lang=js&"
export * from "./SQLEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports